$('.back-to-top').on('click', function () {
	$("html, body").animate({scrollTop: 0}, 600);
});

$(window).on('scroll load', function () {
	if ($('.intro-block').length > 0) {
		if ($(window).scrollTop() > $('.intro-block').offset().top + $('.intro-block').outerHeight()) {
			$('.back-to-top').fadeIn();
		} else {
			$('.back-to-top').fadeOut();
		}
	} else {
		if ($(window).scrollTop() > $('header.main-header').outerHeight()) {
			$('.back-to-top').fadeIn();
		} else {
			$('.back-to-top').fadeOut();
		}
	}
});